// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"75aab01d","294":"61480951","323":"87521e0e","332":"b740638d","375":"6faf5557","421":"89f85fcb","451":"916d6ace","453":"13ac0f49","487":"043142d5","496":"2a6b6f6f","516":"87cad50a","591":"6b31b86a","619":"1a7deb33","773":"279948f6","857":"8e026699","959":"abcce3a0"}[chunkId] + ".chunk.js";
};